import { render, staticRenderFns } from "./TuBiao.vue?vue&type=template&id=3286711e&scoped=true"
import script from "./TuBiao.vue?vue&type=script&lang=js"
export * from "./TuBiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3286711e",
  null
  
)

export default component.exports